import * as api from "api"
import useSWR, { SWRResponse } from "swr"
import JSONAPIDocument from "types/JSONAPIDocument"
import Profile from "types/profile"

const getProfile = async (resource: string): Promise<Profile> =>
    api.request<JSONAPIDocument<Profile>>(resource).then((response) => ({
        ...response.data.attributes,
        id: String(response.data.id),
    }))

/**
 * SWR hook to retrieve the user's profile.
 */
export default function useProfile(): SWRResponse<Profile> {
    return useSWR("/v1/hub/my/profile", getProfile, {
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
        refreshInterval: 0
    })
}
